/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

export interface UnsavedChangesState {
  isDirty: boolean;
  type: UnsavedChangesType;
  showModal: boolean;
  navigateLink?: string;
}

export enum UnsavedChangesType {
  "SITEBUILDER" = "sitebuilder_close",
  "PAYOUT_INFO" = "payout_info_leave",
  "COMPLIANCE" = "compliance_leave",
  "MY_DETAILS" = "my_details_leave",
}
